module.exports = __webpack_public_path__ + "c5084f11952483e0601a73aa28b3a8e8.png";